import React, { useEffect, useState } from 'react';
import { MDBCol, MDBRow } from 'mdbreact';
import { RequestInit } from '../shared/RequestInit';
import CustomDatatable from '../shared/datatables/DataTable';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';

const ListActualite = () => {
  const [infos, setInfos] = useState<any>([{}]);
  const { user } = useSelector((state: RootState) => state.auth);
  console.log(user?.adminRole);

  useEffect(() => {
    const getInfos = async () => {
      await fetch(
        'https://admin.radioemotion.be/api/actualite/getall',
        RequestInit as RequestInit
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.response === true) {
            console.log(response);
            setInfos(response.data);
          } else {
            //setUploadError(true)
          }
        })
        .catch((err) => {
          //setLoading(false)
          // setUploadError(true)
          console.log('error');
        });
    };
    getInfos();
  }, []);

  return (
    <>
      <MDBRow>
        <MDBCol md="9" className="offset-2">
          <CustomDatatable
            props={{ adminRole: user?.adminRole?.info, type: 'actualite' }}
          />
        </MDBCol>
      </MDBRow>
    </>
  );
};

export default ListActualite;
